import React, { useEffect, useState } from "react";
import { useTranslation } from "next-i18next";
import SelectionBlogPosts from "../SelectionBlogPosts/SelectionBlogPosts";
import { useRouter } from 'next/navigation';
import axios from "axios";
import { HandCheck } from "../../assets";

export default function DiscoverSectionDesktopContainer({
    posts
}) {
    const router = useRouter();

    const handleClick = () => {
        router.push('/checkout');
    };

    const [userEmail, setUserEmail] = useState("");
    const [isEmpty, setIsEmpty] = useState(false);
    const [isSend, setIsSend] = useState(false);
    const [lang, setLang] = useState("");

    useEffect(() => {
        const topLevelDomain = window.location.hostname.split(".").pop();
        setLang(topLevelDomain === "es" ? "es" : "fr");
    }, []);

    const susbcriptionNewsLetter = () =>
        axios
            .post("https://eo2uod9d6ddkieu.m.pipedream.net", {
                userEmail,
                lang,
            })
            .then((res) => {
                if (res) {
                    setIsSend(true);
                }
            })
            .catch((error) => {
                console.log(error);
            });

    function handleChange(e) {
        setUserEmail(e.target.value);
    }

    const { t } = useTranslation();
    return (
        <div className="discover_section_desktop_container">
            <SelectionBlogPosts posts={posts} />
            <div className="discover_section_desktop_newsletter_container">
                <p className="discover_section_desktop_newsletter_title">{t("newsletter.title")}</p>
                <p className="discover_section_desktop_newsletter_desc">{t("newsletter.description")}</p>
                {!isSend ? (
                    <>
                        <input className="discover_section_desktop_newsletter_input" type="email" onChange={handleChange} placeholder="miam@benebono.fr" />
                        <div className="discover_section_newsletter_button_container">
                            <div className="discover_section_newsletter_button" style={{ cursor: 'pointer' }} onClick={() => {
                                if (userEmail) {
                                    susbcriptionNewsLetter();
                                }
                                if (!userEmail) {
                                    setIsEmpty(true);
                                }
                            }}>
                                <p>{t("newsletter.button")}</p>
                            </div>
                        </div>
                    </>
                ) : (
                    <>
                        <div className="discover_section_desktop_newsletter_success_newsletter">
                            <HandCheck />
                            <p>{t("newsletter.already.subscribe")}</p>
                        </div>
                    </>
                )}

            </div>
            <div className="discover_section_explanation_container">
                <p className="discover_section_explanation_title">
                    {t("discover.about.bb")}
                </p>
                <div className="discover_section_explanation_card_container">
                    <div className="discover_section_explanation_card">
                        <img src="discoverExplanation1.png" />
                        <div className="discover_section_explanation_card_details">
                            <div className="discover_section_explanation_card_details_title_container">
                                <img src="./discoverExplanationIcon1.png" />
                                <p className="discover_section_explanation_card_details_title">{t("discover.about.eco")}</p>
                            </div>
                            <p className="discover_section_explanation_card_details_desc">{t("discover.about.eco.desc")}</p>
                        </div>
                    </div>
                    <div className="discover_section_explanation_card">
                        <img src="discoverExplanation2.png" />
                        <div className="discover_section_explanation_card_details">
                            <div className="discover_section_explanation_card_details_title_container">
                                <img src="./discoverExplanationIcon2.png" />
                                <p className="discover_section_explanation_card_details_title">{t("discover.about.pra")}</p>
                            </div>
                            <p className="discover_section_explanation_card_details_desc">{t("discover.about.pra.desc")}</p>
                        </div>
                    </div>
                    <div className="discover_section_explanation_card">
                        <img src="discoverExplanation3.png" />
                        <div className="discover_section_explanation_card_details">
                            <div className="discover_section_explanation_card_details_title_container">
                                <img src="./discoverExplanationIcon3.svg" />
                                <p className="discover_section_explanation_card_details_title">{t("discover.about.resp")}</p>
                            </div>
                            <p className="discover_section_explanation_card_details_desc">{t("discover.about.resp.desc")}</p>
                        </div>
                    </div>
                    <div className="discover_section_explanation_card">
                        <img src="discoverExplanation4.png" />
                        <div className="discover_section_explanation_card_details">
                            <div className="discover_section_explanation_card_details_title_container">
                                <img src="./discoverExplanationIcon4.svg" />
                                <p className="discover_section_explanation_card_details_title">{t("discover.about.bon")}</p>
                            </div>
                            <p className="discover_section_explanation_card_details_desc">{t("discover.about.bon.desc")}</p>
                        </div>
                    </div>
                </div>
                <div className="discover_section_explanation_cta" onClick={handleClick} style={{ cursor: "pointer" }}>
                    <p>{t("discover.about.button.cta")}</p>
                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                        <path d="M10.2 17.9167C10.0167 17.7334 9.92505 17.5001 9.92505 17.2167C9.92505 16.9334 10.0167 16.7001 10.2 16.5167L14.1 12.6167L10.2 8.71675C10.0167 8.53341 9.92505 8.30008 9.92505 8.01675C9.92505 7.73341 10.0167 7.50008 10.2 7.31675C10.3834 7.13341 10.6167 7.04175 10.9 7.04175C11.1834 7.04175 11.4167 7.13341 11.6 7.31675L16.2 11.9167C16.3 12.0167 16.371 12.1251 16.413 12.2417C16.4544 12.3584 16.475 12.4834 16.475 12.6167C16.475 12.7501 16.4544 12.8751 16.413 12.9917C16.371 13.1084 16.3 13.2167 16.2 13.3167L11.6 17.9167C11.4167 18.1001 11.1834 18.1917 10.9 18.1917C10.6167 18.1917 10.3834 18.1001 10.2 17.9167Z" fill="#272100" />
                    </svg>
                </div>
            </div>
        </div>
    );
}
